module.exports = __webpack_public_path__ + "static/media/car-yellow.2d82ea1b.svg";